import { useEffect, useState } from "react";

import axios from "axios";
import { ErrorInfo } from "../utils/ErrorInfo";
import LoadingModal from "../utils/LoadingModal";
import FlowChartAdminV from "./DashboardComponents/FlowChartAdminV";
import { RepartitionStockCommerciale } from "./DashboardComponents/RepartitionStockCommerciale";
import Charts from "../Common/Charts";

export default function DashboardAdminV() {
  console.log("CI/CD is working ---------22");
  const [adminV, setAdminV] = useState(null);
  const [outcomingstock, setoutcomingstock] = useState(0);
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const [errorInfo, setErrorInfo] = useState({
    isVisible: false,
    errorMessage: "",
  });


  const getfullinfo = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}auth/check/`,
        { withCredentials: true }
      );
      if (response.status === 200) {
        const userId = response.data?.data?._id;
        const AdminVInfoResponse = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}admin_vente/${userId}/`,
          { withCredentials: true }
        );
        setAdminV(AdminVInfoResponse.data);
      }
    } catch (error) {
      setError(error.response?.data?.message || "Erreur inconnue");
      setErrorInfo({
        isVisible: true,
        errorMessage: error.response?.data?.message || "Erreur inconnue",
      });
    }
    setLoading(false);
  };

  const getUserPendingTransactionsAmount = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}userPendingTransactionsAmount`,
        {
          withCredentials: true,
        }
      );

      if (response.status === 200) {
        setoutcomingstock(response.data.totalPendingAmount);
      }
    } catch (error) {
      setError(
        error.response?.data?.message ||
          "Erreur lors de la récupération des transactions"
      );
      setErrorInfo({
        isVisible: true,
        errorMessage:
          error.response?.data?.message ||
          "Erreur lors de la récupération des transactions",
      });
    }
  };

  useEffect(() => {
    getfullinfo();
    getUserPendingTransactionsAmount();
  }, []);

  return (
    <div>
      {errorInfo.isVisible && (
        <ErrorInfo
          onClose={() => setErrorInfo({ ...errorInfo, isVisible: false })}
          errorMessage={error}
        />
      )}
      {loading && <LoadingModal></LoadingModal>}
      <div className="dark:bg-gray-900">
        {adminV &&
           (
            <>
              <div className="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-2 2xl:grid-cols-2 mb-4">
                <div className="relative items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800">
                  <div className="w-full">
                    <h3 className="text-base font-normal text-gray-500 dark:text-gray-400">
                      Votre stock
                    </h3>
                    <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                      {adminV?.StockTotal}
                    </span>
                  </div>
                </div>

                <div className="items-center justify-between p-4 bg-white border border-gray-200 rounded-lg shadow-sm sm:flex dark:border-gray-700 sm:p-6 dark:bg-gray-800">
                  <div className="w-full">
                    <h3 className="text-base font-normal text-gray-500 dark:text-gray-400">
                      Stock sortant en attente d'acceptation
                    </h3>
                    <span className="text-2xl font-bold leading-none text-gray-900 sm:text-3xl dark:text-white">
                      {outcomingstock}{" "}
                    </span>
                  </div>
                </div>
              </div>
              <div className="grid w-full grid-cols-1 gap-4 mt-4 xl:grid-cols-1 2xl:grid-cols-1 mb-4">
                <FlowChartAdminV/>
              </div>

              <RepartitionStockCommerciale></RepartitionStockCommerciale>
              <Charts/>
            </>
          )}
      </div>
    </div>
  );
}
